import angular from 'angular';

export default function FindingController(
  $q,
  $rootScope,
  $scope,
  alerts,
  amDataService,
  amSharedModelService,
  attachFindingDialog,
  confirmDialog,
  docDataService,
  serviceIds,
  editFindingCommentDialog,
  editFindingDialog,
  loaderService,
  orgDataService,
  ssDialogService
) {
  const vm = this;

  // Set Default Values
  vm.serviceId = serviceIds.AM;

  vm.canExpand = vm.status !== 'No Finding Added';
  vm.isExpanded = false;

  // Attach Event Handlers
  vm.handleExpandFinding = _handleExpandFinding;
  vm.handleEditFinding = _handleEditFinding;
  vm.handleDeleteFinding = _handleDeleteFinding;
  vm.handleAddFindingNote = _handleAddFindingNote;
  vm.handleMarkStatusComplete = _handleMarkStatusComplete;
  vm.handleAttachItems = _handleAttachItems;
  vm.documentAttached = _documentAttached;
  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;
  vm.handleConfirmComplete = _handleConfirmComplete;
  vm.handleCancelComplete = _handleCancelComplete;

  _activate();

  // //////// METHODS //////////

  _initEventListeners();

  function _activate() {
    _setStatuses();
    const dfdActivate = $q.defer();

    _refreshBusinessRisks().then(
      _refreshTechnicalRisks().then(
        _refreshPriorities().then(
          _refreshFindingStatuses().then(
            _refreshUsers().then(dfdActivate.resolve)
          )
        )
      )
    );
  }

  function _initEventListeners() {
    $scope.$on('refreshAMBusinessRisks', _refreshBusinessRisks);
    $scope.$on('refreshAMTechnicalRisks', _refreshTechnicalRisks);
    $scope.$on('refreshAMPriorities', _refreshPriorities);
    $scope.$on('refreshAMUsers', _refreshUsers);

    $scope.$on('refreshAMFinding', (event, opt) => {
      if (opt.findingId === vm.finding.findingId) {
        _refreshFinding();
      }
    });

    $scope.$on('refreshAMFindingComments', (event, opt) => {
      if (opt.findingId === vm.finding.findingId) {
        _refreshFindingComments();
      }
    });

    $scope.$on('refreshAMFindingFolders', (event, opt) => {
      if (opt.findingId === vm.finding.findingId) {
        _refreshFindingFolders();
      }
    });

    $scope.$on('refreshAMFindingDocuments', (event, opt) => {
      if (opt.findingId === vm.finding.findingId) {
        _refreshFindingDocuments();
      }
    });

    $scope.$on('refreshAMFindingReports', (event, opt) => {
      if (opt.findingId === vm.finding.findingId) {
        _refreshFindingReports();
      }
    });

    $scope.$on('refreshFolderAttachments', () => {
      _refreshFindingFolders();
      _refreshFindingDocuments();
      _refreshFindingReports();
    });

    $scope.$on('refreshDocAttachments', (event, opt) => {
      let docisAttached = false;
      angular.forEach(vm.finding.findingDocuments, (findingDocument) => {
        if (findingDocument.documentId === opt.document.documentId) {
          docisAttached = true;
        }
      });

      if (docisAttached) {
        _refreshFindingDocuments();
      }
    });
  }

  function _setStatuses() {
    vm.finding.canAddItemNote = (vm.finding.canAddNote || vm.finding.isAssignedToMe) && vm.auditIsActive;
    vm.finding.canAttachItemItems = (vm.finding.canAttachItems || vm.finding.isAssignedToMe) && vm.auditIsActive;

    vm.finding.canChangeItemStatus = (vm.finding.canChangeStatus || vm.finding.isAssignedToMe || vm.finding.canEdit)
      && vm.finding.statusId !== 3 && vm.auditIsActive;

    vm.finding.canEditItem = vm.finding.canEdit && vm.auditIsActive;
    vm.finding.canDeleteItem = vm.finding.canDelete && vm.auditIsActive;
  }

  function _handleExpandFinding() {
    vm.isExpanded = !vm.isExpanded;

    if (vm.isExpanded) {
      _refreshFinding();
    }
  }

  function _refreshFinding() {
    const dfdRefresh = $q.defer();

    amDataService.getFinding(vm.finding.findingId).then((response) => {
      vm.finding = response.data;
      _setStatuses();
      dfdRefresh.resolve();
    });

    return dfdRefresh.promise;
  }

  function _refreshFindingComments() {
    const dfdRefresh = $q.defer();

    amDataService.getFindingCommentsByFinding(vm.finding.findingId).then((response) => {
      vm.finding.findingComments = response.data.result;
      dfdRefresh.resolve();
    });

    return dfdRefresh.promise;
  }

  function _refreshFindingFolders() {
    const dfdRefresh = $q.defer();

    amDataService.getFindingFoldersByFinding(vm.finding.findingId).then((response) => {
      vm.finding.findingFolders = response.data.result;
      dfdRefresh.resolve();
    });

    return dfdRefresh.promise;
  }

  function _refreshFindingDocuments() {
    const dfdRefresh = $q.defer();

    amDataService.getFindingDocumentsByFinding(vm.finding.findingId).then((response) => {
      vm.finding.findingDocuments = response.data.result;
      dfdRefresh.resolve();
    });

    return dfdRefresh.promise;
  }

  function _refreshFindingReports() {
    const dfdRefresh = $q.defer();

    amDataService.getFindingReportsByFinding(vm.finding.findingId).then((response) => {
      vm.finding.findingReports = response.data.result;
      dfdRefresh.resolve();
    });

    return dfdRefresh.promise;
  }

  function _refreshBusinessRisks() {
    return amSharedModelService.getBusinessRisks().then((businessRisks) => {
      vm.businessRisks = businessRisks;
    });
  }

  function _refreshTechnicalRisks() {
    const dfdRefresh = $q.defer();

    vm.technicalRisks = amSharedModelService.technicalRisks;
    dfdRefresh.resolve();

    return dfdRefresh.promise;
  }

  function _refreshPriorities() {
    const dfdRefresh = $q.defer();

    vm.priorities = amSharedModelService.priorities;
    dfdRefresh.resolve();

    return dfdRefresh.promise;
  }

  function _refreshFindingStatuses() {
    const dfdRefresh = $q.defer();

    vm.statuses = amSharedModelService.findingStatuses;
    dfdRefresh.resolve();

    return dfdRefresh.promise;
  }

  function _refreshUsers() {
    const dfdRefresh = $q.defer();

    vm.users = amSharedModelService.applicationUsers;
    dfdRefresh.resolve();

    return dfdRefresh.promise;
  }

  function _handleEditFinding($event) {
    loaderService.showViewLoader = true;
    _refreshFinding().then(() => {
      ssDialogService.dialogs.auditTrail.editFindingDialog = ssDialogService.alert(
        editFindingDialog.getOptions($event, {
          customerId: vm.customerId,
          auditId: vm.auditId,
          auditIsActive: vm.auditIsActive,
          businessRisks: vm.businessRisks,
          technicalRisks: vm.technicalRisks,
          priorities: vm.priorities,
          statuses: vm.statuses,
          users: vm.users,
          finding: vm.finding,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.auditTrail.editFindingDialog);
      loaderService.showViewLoader = false;
    });
  }

  function _handleAddFindingNote($event) {
    ssDialogService.dialogs.auditTrail.editFindingCommentDialog = ssDialogService.alert(
      editFindingCommentDialog.getOptions($event, {
        findingId: vm.finding.findingId,
        findingCommentId: -1,
        findingCommentText: '',
      })
    );
    ssDialogService.show(ssDialogService.dialogs.auditTrail.editFindingCommentDialog);
  }

  function _handleAttachItems($event) {
    loaderService.showViewLoader = true;
    docDataService.getFolderProperties(-1).then((getFolderResponse) => {
      vm.rootFolder = getFolderResponse.data;

      ssDialogService.dialogs.auditTrail.attachFindingDialog = ssDialogService.alert(
        attachFindingDialog.getOptions($event, {
          serviceId: vm.serviceId,
          findingId: vm.finding.findingId,
          folder: vm.rootFolder,
          attachCallback: vm.documentAttached,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.auditTrail.attachFindingDialog);
    });
  }

  function _documentAttached() {
    $rootScope.$broadcast('refreshAMFinding', { findingId: vm.finding.findingId });
  }

  // /////////////// Delete /////////////////

  function _handleDeleteFinding($event) {
    ssDialogService.dialogs.auditTrail.deleteFindingConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Finding?',
        message: `Are you sure you want to delete Finding "${vm.finding.name}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.auditTrail.deleteFindingConfirmDialog);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return amSharedModelService.deleteFinding(vm.finding)
      .then(() => {
        // deleteCallback is wrapped in a function by Angular
        vm.deleteCallback()(vm.finding);
        alerts.success('The Finding has been deleted successfully.');
        $rootScope.$broadcast('refreshNotifications');
        _closeDeleteDialog();
      }).catch(() => {
        alerts.error('Error occurred while deleting the Finding.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.auditTrail.deleteFindingConfirmDialog);
  }

  // /////////////// Complete /////////////////

  function _handleMarkStatusComplete($event) {
    ssDialogService.dialogs.auditTrail.completeFindingConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Complete Finding?',
        message: `Are you sure you want to mark Finding "${vm.finding.name}" as completed?`,
        handleYesClick: _handleConfirmComplete,
        handleNoClick: _handleCancelComplete,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.auditTrail.completeFindingConfirmDialog);
  }

  function _handleConfirmComplete() {
    loaderService.showViewLoader = true;
    amDataService.setFindingStatus(vm.finding.findingId, 3).then((response) => {
      if (response.status !== 201) {
        alerts.error('Error occurred while marking the Finding complete.');
      } else {
        loaderService.showViewLoader = false;
        alerts.success('The Finding has successfully been marked as complete.');
        $rootScope.$broadcast('refreshAMFinding', { findingId: vm.finding.findingId });
        $rootScope.$broadcast('refreshNotifications');
        _closeCompleteDialog();
      }
    });
  }

  function _handleCancelComplete() {
    _closeCompleteDialog();
  }

  function _closeCompleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.auditTrail.completeFindingConfirmDialog);
  }
}

FindingController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'amDataService',
  'amSharedModelService',
  'attachFindingDialog',
  'confirmDialog',
  'docDataService',
  'serviceIds',
  'editFindingCommentDialog',
  'editFindingDialog',
  'loaderService',
  'orgDataService',
  'ssDialogService'
];
